module.exports = __webpack_public_path__ + "media/img/pages/companies/schindler-095669608857b022a11c5a97a8f08287.png";